import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=623b95f9&scoped=true&"
import script from "./ClientCard.vue?vue&type=script&lang=ts&"
export * from "./ClientCard.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=623b95f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b95f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
